import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { UserModalService } from './user-modal.service';
import { Principal, JhiLanguageHelper, User, UserService, CRUD_ACTIONS } from '../../shared';

import { studentGlobalLocations } from '../../shared/constants/student.locations.constants';
import {SchoolService} from '../../entities/school/school.service';
import {School} from '../../entities/school/school.model';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';



@Component({
    selector: 'jhi-user-mgmt-dialog',
    templateUrl: './user-management-dialog.component.html'
})
export class UserMgmtDialogComponent implements OnInit {

    user: User;
    languages: any[];
    authorities: any[];
    isSaving: Boolean;
    schools: School[];

    constructor(
        public activeModal: NgbActiveModal,
        private languageHelper: JhiLanguageHelper,
        private jhiLanguageService: JhiLanguageService,
        private userService: UserService,
        private schoolService: SchoolService,
        private eventManager: EventManager,
        private principal: Principal
    ) { }

    ngOnInit() {
        this.isSaving = false;
        if (this.principal.hasAnyAuthoritySync(['ROLE_ADMIN']) === true) {
            this.authorities = ['ROLE_USER', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER', 'ROLE_SCHOOL_ADMIN', 'ROLE_ADMIN'];
        } else if ((this.principal.hasAnyAuthoritySync(['ROLE_SCHOOL_ADMIN']) === true)) {
            this.authorities = ['ROLE_USER', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER', 'ROLE_SCHOOL_ADMIN'];
        } else {
            this.authorities = ['ROLE_USER'];
        }

        this.principal.hasAnyAuthority(['ROLE_ADMIN']).then(isAdmin => {
            if (isAdmin) {
                this.schoolService.query().subscribe(
                    (res: HttpResponse<School[]>) => { this.schools = res.body; }, (error: HttpErrorResponse) => console.log(error.error));
            }
        });

        this.languageHelper.getAll().then((languages) => {
            this.languages = languages;
        });
        this.jhiLanguageService.setLocations(studentGlobalLocations);
    }

    setAuthorities() {
        if (this.user.authorities.indexOf('ROLE_SCHOOL_ADMIN') > -1 ) {
            this.user.authorities = ['ROLE_SCHOOL_ADMIN', 'ROLE_ADVANCED_TEACHER', 'ROLE_TEACHER', 'ROLE_USER'];
            return;
        }

        if (this.user.authorities.indexOf('ROLE_ADVANCED_TEACHER') > -1 ) {
            this.user.authorities = ['ROLE_ADVANCED_TEACHER', 'ROLE_TEACHER', 'ROLE_USER'];
            return;
        }

        if (this.user.authorities.indexOf('ROLE_TEACHER') > -1 ) {
            this.user.authorities = ['ROLE_TEACHER', 'ROLE_USER'];
            return;
        }
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.user.id !== null) {
            this.userService
                .update(this.user)
                .subscribe(response => this.onSaveSuccess(response, CRUD_ACTIONS.UPDATE),
                                                                  () => this.onSaveError());
        } else {
            this.userService
                .create(this.user)
                .subscribe(response => this.onSaveSuccess(response, CRUD_ACTIONS.UPDATE),
                                                                  () => this.onSaveError());
        }
    }

    private onSaveSuccess(result: User, action: String) {
        this.eventManager.broadcast({ name: 'userListModification',  content: {
            action: action,
            content: result
        }});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError() {
        this.isSaving = false;
    }
}

@Component({
    selector: 'jhi-user-dialog',
    template: ''
})
export class UserDialogComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private userModalService: UserModalService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['login']) {
                this.modalRef = this.userModalService.open(UserMgmtDialogComponent as Component, params['login']);
            } else {
                setTimeout(() => {
                    // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                    this.modalRef = this.userModalService.open(UserMgmtDialogComponent as Component);
                });
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-management/user-management-dialog.component.ts